/**
 * NE4: STIMMEN DIE CONNECTS? (.603)
 *
 * ORIGINALTEXT MARVIN (02.11.2026)
 *   „liest das System jetzt allgemein die Connects vorher richtig aus, damit man sieht beim Anlegen des Auftrages,
 *    wie viel Connects da sind, ob das nachher dann auch übereinstimmt mit dem, was der Kunde gemeldet hat, was dann
 *    schon terminiert bzw. erledigt ist, zu welchem Datum das erledigt wurde, dass wir da ein sauberes System bei
 *    uns haben."
 *
 * Drei Zahlen nebeneinander: die Connects im Bulk-Portal (GFTA-Sockets der Telekom), was das Haus laut Kunde hat
 * (WE + GE + SL, bestätigt oder gemeldet) und was die Auskundung sagt (WE + GE). Weichen sie ab, steht das am Haus
 * und in der Liste. Ohne eine Zahl gibt es kein Urteil.
 */
export function connectAbgleich(a: any, portal: number | null | undefined): { portal: number | null; haus: number | null; auskundung: number | null; passt: boolean | null } {
  const zahl = (x: any) => (x == null || x === '' ? null : Number(x));
  const we = zahl(a?.wohneinheiten), ge = zahl(a?.ge), sl = zahl(a?.sl);
  const haus = we == null && ge == null ? null : (we ?? 0) + (ge ?? 0) + (sl ?? 0);
  const aw = a?.auskundung_werte ?? null;
  const auskundung = aw && (aw.we != null || aw.ge != null) ? Number(aw.we ?? 0) + Number(aw.ge ?? 0) : null;
  const p = portal == null ? null : Number(portal);
  const passt = p == null || !p || haus == null ? null : p === haus && (auskundung == null || auskundung === p);
  return { portal: p || null, haus, auskundung, passt };
}

/** Die Connects je Tag: „15.09.2026: Connect 1, 9". */
export function nachTag(liste: { tag: string; name: string }[]): string[] {
  const m = new Map<string, string[]>();
  for (const x of [...liste].sort((a, b) => a.tag.localeCompare(b.tag))) m.set(x.tag, [...(m.get(x.tag) ?? []), x.name]);
  return [...m.entries()].map(([t, n]) => `${t.split('-').reverse().join('.')}: ${n.join(', ')}`);
}
